"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Xfce = function Xfce(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M.01 5.756c-.128.07 1.019.82 3.161 1.706 2.143.886 5.103 3.13 4.87 3.493-.695.984-1.105 2.162-.822 4.178.051.355-1.047.97-.968 1.506.067.408 1.228-.403 1.355-.243.078.288-.621 1.743-.338 1.847.206.062 2.023-1.73 2.129-1.7 2.995.908 6.892.222 6.967.194-.007-.016 2.804 1.326 3.049 1.166.616-.67-1.169-1.615-.871-1.992.13-.198 2.173.742 2.274.485.146-.443-.948-1.375-1.113-1.651-.143-.255-.174-.666.194-.924.367-.257 4.125-1.7 3.967-2.818-.272-2.03-4.766-2.161-4.839-2.332-.034-.08.199-2.902-1.112-2.38-.808.301-.15 2.099-.097 2.332.048.214-.359.19-.436.097-.17-.21-.736-2.084-1.403-1.75-.935.518-.055 2.135-.242 2.187-.346.195-.326.67-.604 1.056-.458.66-3.886-.309-4.994-.376-.811-.048-1.586.62-1.66.535-.987-.993-3.03-2.722-5.27-3.297C1.953 6.733.086 5.743.01 5.755zm22.866 1.816c-.068-.018-.382 1.593-.234 1.665.13.097.355-1.576.237-1.662l-.003-.002zm1.107.213c-.17-.003-1.076 1.449-.867 1.603.129.098.937-1.543.881-1.598a.024.024 0 00-.014-.005zm-4.385 1.768a.388.444 0 01.388.443.388.444 0 01-.388.444.388.444 0 01-.388-.444.388.444 0 01.388-.443zm-.871.27c.165.714.422.94 1.194.918-.983.905-1.58-.645-1.194-.919zm2.125 1.867c.04 0 .071.011.092.03.387.141-1.664.883-1.678.778-.021-.075 1.197-.823 1.586-.808zm.208.475a.1.1 0 01.056.009c.365.364-1.157 1.173-1.14 1.144-.123-.074.766-1.129 1.084-1.154z"
  }));
};

Xfce.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Xfce.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Xfce;
exports.default = _default;